export type RGB = [number, number, number];

function isValidHex(s: string): boolean {
  const validHexPattern = /^#([0-9A-F]{3}){1,2}$/i;
  return validHexPattern.test(s);
}

/**
 * Takes a hexadecimal colour code and converts it to an array of RGB values.
 *
 * @param hex A valid hexadecimal colour code. Accepts 3- and 6-digit codes, but
 *            dose not accept codes with alpha values.
 * @returns An array with three numbers, representing RGB values.
 */
export function parseRgb(hex: string) {
  if (!isValidHex(hex))
    throw new Error(`${hex} is not a valid hexadecimal colour code.`);

  hex = hex.slice(1);
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  const value = parseInt(hex, 16);
  const r = (value >> 16) & 255;
  const g = (value >> 8) & 255;
  const b = value & 255;

  return [r, g, b] as RGB;
}
